import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export var RESET_PAGINATION = 'RESET_PAGINATION';
export var RESET_FILTERS = 'RESET_FILTERS';
export var FILTER_BY = 'FILTER_BY';
export var SORT_BY = 'SORT_BY';
export var ORDER_BY = 'ORDER_BY';
export var SET_PREVIOUS_PAGE = 'SET_PREVIOUS_PAGE';
export var SET_NEXT_PAGE = 'SET_NEXT_PAGE';
export var SET_DEFAULT_FILTERBY = 'SET_DEFAULT_FILTERBY';
export var SET_DEFAULT_SORTBY = 'SET_DEFAULT_SORTBY';
export var SET_DEFAULT_ORDERBY = 'SET_DEFAULT_ORDERBY';